/**
 * バージョン履歴のブランチ図（マージなし・レーン再利用）
 * 上から新しい順に並んだ版を受け取り、各行のレーンと描く線を決める。
 * lanes[x] = そのレーンが下で待っている版（= 上の子の親）。同じ親を待つレーンが複数あれば、親の行で合流させて解放する。
 * @param {Array<{v:number, parent:number|null, draft:boolean}>} nodes
 * @returns {{rows: Array<{lane:number, fromAbove:boolean, fromAboveChild:number|null, fromAboveDraft:boolean,
 *   joins:Array<{lane:number, child:number, draft:boolean}>, through:Array<{lane:number, v:number, child:number}>}>, laneCount:number}}
 */
export const layoutBranches = (nodes) => {
    const lanes = [];
    const rows = nodes.map((n) => {
        const hits = lanes.map((l, x) => (l && l.v === n.v ? x : -1)).filter((x) => x >= 0);
        let lane;
        let fromAbove = false;
        let fromAboveChild = null;
        let fromAboveDraft = false;
        if (hits.length) {
            lane = hits[0];
            fromAbove = true;
            fromAboveChild = lanes[lane].child;
            fromAboveDraft = lanes[lane].draft;
        } else {
            lane = lanes.findIndex((l) => !l);
            if (lane < 0) {
                lane = lanes.length;
                lanes.push(null);
            }
        }
        const joins = hits.slice(1).map((x) => ({ lane: x, child: lanes[x].child, draft: lanes[x].draft }));
        const through = lanes
            .map((l, x) => (l && x !== lane && !hits.includes(x) ? { lane: x, v: l.v, child: l.child } : null))
            .filter(Boolean);
        joins.forEach((j) => { lanes[j.lane] = null; });
        lanes[lane] = n.parent !== null && n.parent !== undefined ? { v: n.parent, child: n.v, draft: !!n.draft } : null;
        return { lane, fromAbove, fromAboveChild, fromAboveDraft, joins, through };
    });
    return { rows, laneCount: Math.max(1, lanes.length) };
};

/**
 * 選択中の版から根までの祖先（系譜）を集める
 * @returns {Object<number, true>}
 */
export const lineageOf = (nodes, selV) => {
    const byV = new Map(nodes.map((n) => [n.v, n]));
    const lineage = {};
    let cur = byV.get(selV);
    while (cur && !lineage[cur.v]) {
        lineage[cur.v] = true;
        cur = cur.parent !== null && cur.parent !== undefined ? byV.get(cur.parent) : null;
    }
    return lineage;
};

/**
 * 図の表示範囲（visible レーン分だけ見せ、選択中のレーンが右端に来るよう横にずらす）
 */
export const graphWindow = (selLane, laneCount, visible) => {
    const shift = Math.max(0, selLane - (visible - 1));
    return {
        shift,
        visLanes: Math.min(visible, laneCount),
        clipLeft: shift > 0,
        clipRight: shift + visible < laneCount,
    };
};
